import { render, staticRenderFns } from "./CourseAudioPlayer.vue?vue&type=template&id=864f8f60&"
import script from "./CourseAudioPlayer.vue?vue&type=script&lang=js&"
export * from "./CourseAudioPlayer.vue?vue&type=script&lang=js&"
import style0 from "./CourseAudioPlayer.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports